import { AgentType, Model, MotionMapperType } from "../models/Model";
import { BaseVisual } from "./BaseVisual";
import { C4Visual } from "./C4Visual";
import { FloorVisual } from "./FloorVisual";
import { LightVisual } from "./LightVisual";
import { MarkerVisual } from "./MarkerVisual";

const registry = new Map<string, IntristicVisualModel>();

registerIntristicVisual(new LightVisual(), 'Attributes', 'Light');
registerIntristicVisual(new FloorVisual(), 'Attributes', 'Floor');
registerIntristicVisual(new MarkerVisual(), 'Attributes', 'Marker');
registerIntristicVisual(new C4Visual(), 'Vehicles', 'C4');

export function registerIntristicVisual(visual: BaseVisual, category: string, name: string) {
  const type = visual.getType();
  const model: IntristicVisualModel = {
    c: visual.constructor as new () => BaseVisual,
    _id: type,
    orgId: '',
    visualType: type,
    source: {
      url: '',
      blobId: ''
    },
    adaptation: {
      scale: 1.0,
      rotation: { x: 0, y: 0, z: 0 },
      position: { x: 0, y: 0, z: 0 }
    },
    name,
    category,
    settings: {
      lastEdit: Date.now(),
      cameraPosition: undefined
    },
    motionMapper: {
      type: MotionMapperType.Unknown,
    },
    collisionMap: {
      boxes: []
    },
    agentType: AgentType.Static,
    parts: [],
    manifest: "",
  };
  registry.set(type, model);
}

export interface IntristicVisualModel extends Model {
  visualType: string; // Type of the visual
  c: new () => BaseVisual; // Constructor for the visual
}

export function getIntristicModels(): IntristicVisualModel[] {
  return Array.from(registry.values());
}

export function createIntristicVisual(model: IntristicVisualModel): BaseVisual {
  const visual = new model.c();
  return visual;
}